<!-- 报价单 -->
<template>
    <div id="bj" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>询价管理</el-breadcrumb-item>
                <el-breadcrumb-item>报价单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">报价单号:</div>
            <el-input
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.QCode"
                    placeholder="请输入报价单号">

            </el-input>
            <div class="search-name">时间:</div>
            <el-date-picker
                    :picker-options="startDateOps"
                    class="search-item"
                    v-model="searchData.StartDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                    :picker-options="endDateOps"
                    class="search-item"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="searchData.EndDate"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <div class="search-name">客服组:</div>
            <el-select
                    @change="getServicesByGId"
                    size="small"
                    class="search-item"
                    v-model="searchData.GroupId"
                    placeholder="请选择">
                <el-option
                        v-for="item in serviceGroup"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id">
                </el-option>
            </el-select>
            <div class="search-name">客服人员:</div>
            <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.Id"
                    placeholder="请选择">
                <el-option
                        v-for="item in services"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id">
                </el-option>
            </el-select>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="table-ctn">
            <el-table
                    :header-cell-style="{background:'#F2F6FC'}"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="QCode"
                        label="单号">
                </el-table-column>
                <el-table-column
                        prop="UName"
                        label="客户名称">
                </el-table-column>
                <el-table-column
                        prop="PriceSumCome"
                        label="进价金额总计">
                </el-table-column>
                <el-table-column
                        prop="UName"
                        label="询价人">
                </el-table-column>
                <el-table-column
                        prop="QName"
                        label="报价人">
                </el-table-column>
                <el-table-column
                        prop="ITime"
                        label="询价时间">
                </el-table-column>
                <el-table-column
                        prop="QTime"
                        label="报价时间">
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template slot-scope="scope">
                        <!--todo 这里还需要推送零时商品的功能-->
                        <el-button type="text" size="small" @click="showDialog(scope.row)">转为订单</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
        <div>
            <el-dialog title="转为订单" :visible.sync="dialogVisible">
                <el-form :model="toOrderData">
                    <el-form-item label="询价单Id" :label-width="formLabelWidth" style="display: none;">
                        <el-input  v-model="toOrderData.IBId"></el-input>
                    </el-form-item>
                    <el-form-item label="企业Id" :label-width="formLabelWidth" style="display: none;">
                        <el-input v-model="toOrderData.EntpId"></el-input>
                    </el-form-item>
                    <el-form-item label="优惠金额" :label-width="formLabelWidth">
                        <el-input v-model.trim="toOrderData.DiscountAmount"  @blur="DiscountAmountChange"></el-input>
                    </el-form-item>
                    <el-form-item label="发货地址" :label-width="formLabelWidth">
                        <el-input v-model.trim="toOrderData.ShipAddr"></el-input>
                    </el-form-item>
                    <el-form-item label="发货方式名称" :label-width="formLabelWidth">
                        <el-select v-model="toOrderData.ShipTypeName" placeholder="请选择">
                            <el-option
                                    v-for="item in ShipType"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单合计" :label-width="formLabelWidth">
                        <el-input v-model="toOrderData.OrderAmount" readonly></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showToOrder = false">取 消</el-button>
                    <el-button type="primary" @click="toOrder">转为订单</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'bj',
        components: {},
        data() {
            return {
                startDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.EndDate != "") {
                            return  time.getTime() > new Date(this.searchData.EndDate);
                        }

                    }
                },
                endDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.StartDate != "") {
                            return  time.getTime() < new Date(this.searchData.StartDate);
                        }

                    }
                },
                dialogVisible:false,
                serviceGroup:[],
                services:[],
                ShipType:[ // 发货方式
                    {label:'货运场自提',value:'7'},
                    {label:'送货门店',value:'5'},
                    {label:'自提',value:'0'},
                    {label:'物流',value:'2'},
                    {label:'门店自提',value:'8'},
                    {label:'快递',value:'1'},
                    {label:'海运',value:'4'},
                    {label:'送货仓库',value:'6'},
                    {label:'空运',value:'3'},
                ],
                searchData: {
                    QCode:'', //报价单号
                    SId:'', // 客服的ID
                    StartDate:'', //
                    EndDate:'', //
                    GroupId:'', // 客服组的ID
                    page:1,
                    limit:10,
                    key:''
                },
                // 要转的订单数据
                toOrderOrange:{},
                // 转为订单数据
                toOrderData:{
                    IBId:'',
                    EntpId:'',
                    DiscountAmount:'',
                    ShipAddr:'',
                    ShipTypeName:'',
                    OrderAmount:'',
                },
                formLabelWidth: '120px',
                tableData: [],
                tableDataLength:0,
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            // 优惠金额改变
            DiscountAmountChange(){
                let yh = Number(this.toOrderData.DiscountAmount)
                let oprice = Number(this.toOrderOrange.PriceSumCome)
                if (oprice < yh){
                    this.$message({
                        message: '优惠价格不能大于订单总价',
                        type: 'warning'
                    });
                    return
                }
                else {
                    this.toOrderData.OrderAmount = oprice - yh
                }
            },
            // 转为订单
            toOrder(){
                this.axios.post('/Inquiry/TransferToOrder',this.toOrderData)
                    .then(()=> {
                        this.$message({
                            message: '转为订单成功',
                            type: 'success'
                        });
                        this.dialogVisible = false
                        this.toOrderData = {
                            IBId:'',
                            EntpId:'',
                            DiscountAmount:'',
                            ShipAddr:'',
                            ShipTypeName:'',
                            OrderAmount:'',
                        }


                    })
                    .catch((error)=>{
                        this.$message.error(error);
                    });
            },
            showDialog(data){
                this.toOrderOrange = data
                this.toOrderData.IBId = data.Id
                this.toOrderData.EntpId = data.UId
                this.dialogVisible = true
            },
            // 加载报价表
            getTableData(){
                this.axios.get('/Inquiry/LoadQuotes',{
                    params: this.searchData

                })
                    .then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            //  根据客服组ID获取所有在职客服
            getServicesByGId(gId){
                this.$util.GetServicesByGId(gId).then(value => {
                    this.services = value
                    this.searchData.Id = ''
                })
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    Id:'',
                    StartDate:'',
                    EndDate:'',
                    GroupId:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                    key:'', //关键字查询
                }
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>

</style>
